export const environment = {
  apiUrl: 'https://dev-tenso.btspo.co/api/v1',
  mapboxToken: 'pk.eyJ1IjoibWFwYm94YnQiLCJhIjoiY202ZmtwdW10MDYzdjJrcHkxeHluYnlnZyJ9.boQyDbMXYHb4aAdp5ocilQ',
  stripeEnabled: true,
  openpayEnabled: false,
  version: '0.0.7',
};
